/* eslint-disable no-param-reassign */
import { Images as ABCyaImages, Audio as ABCyaAudio } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import BlobBase from './BlobBase';

export default class BlobPush extends BlobBase {

  constructor (scene, row, col, direction) {
    super(scene);

    /*  direction1,
         actionDirection1:
         -1 - None,
         0 - Up,
         1 - Right,
         2 - Down,
         3 - Left,
         6 - All.
         */

    this.name = 'BlobPush';
    this.row = row;
    this.column = col;
    this.direction = direction;
    this.enabled = true;
    this.movable = true;
    this.playingAnim = false;

    // create static man
    this.animation = this.scene.add.sprite(0, 0, ABCyaImages.DEFAULT_ATLAS, UIAssetKeys._blob_push_0);
    this.add(this.animation);

    const delay = Phaser.Math.Between(0, 1000);
    let initialAnimationDelay = this.scene.time.delayedCall(delay, () => {this.animation.play({ key: 'push_pause', repeat: -1 });});

    this.animation.x -= 160 + this.animation.width / 2;
    this.animation.y -= 68 + this.animation.height / 2;

    this.animation.setInteractive({ pixelPerfect: true });

    this.animation.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      if (!this.enabled) return;

      const array = this.parentContainer.canPushBlock(this, this.direction, 0);
      const canPush = array[0];
      const numBlocksTilEmptyBlock = array[1];

      if (canPush) {
        this.enabled = false;
        this.playingAnim = true;

        if (initialAnimationDelay) {
          initialAnimationDelay.remove();
          initialAnimationDelay = null;
        }
        this.animation.play('push');
        this.animation.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
          this.enabled = true;
          this.playingAnim = false;
        });

        ABCyaAudio.playOneShot('Push_Blob', this.scene);

        this.parentContainer.moveBlocks(this, this.direction, numBlocksTilEmptyBlock + 1, false);

        return;
      }

      const oppositeDirection = this.oppositeDirection(this.direction);

      const array2 = this.parentContainer.canPushBlock(this, oppositeDirection, 0);
      const canPush2 = array2[0];
      const numBlocksTilEmptyBlock2 = array2[1];

      if (canPush2) {
        this.enabled = false;
        this.playingAnim = true;
        this.animation.play('push');
        this.animation.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
          this.enabled = true;
          this.playingAnim = false;
        });

        ABCyaAudio.playOneShot('Push_Blob', this.scene);

        this.parentContainer.moveBlocksBackwards(this, this.direction, numBlocksTilEmptyBlock2 + 1, false);
      }
    });
  };
}